import cx from "classnames";
import { ReactNode } from "react";

import "static/styles/components/design/divider.css";

type OrientationProps =
  | {
      orientation?: "horizontal";
      children?: ReactNode;
      fullHeight?: never;
    }
  | {
      orientation: "vertical";
      children?: never;
      fullHeight?: boolean;
    };

type DividerProps = {
  color?: "grey" | "light-grey" | "dark-grey";
  type?: "solid" | "dashed" | "dotted" | "faded_solid";
  classNames?: string;
} & OrientationProps;

export const Divider = ({
  children,
  color = "grey",
  type = "solid",
  orientation = "horizontal",
  fullHeight,
  classNames = "",
}: DividerProps): React.JSX.Element => {
  const isFaded = type === "faded_solid";

  if (isFaded) {
    return (
      <div
        className={cx("custom-divider t-flex t-items-center", {
          "t-h-full": fullHeight,
          [classNames]: Boolean(classNames),
        })}
      >
        <div className="t-flex-1 t-h-px t-bg-separator-fade-left" />

        {children && (
          <>
            <p
              className={cx(
                "t-mx-3 t-mb-0 t-whitespace-nowrap t-flex-shrink-0",
                {
                  "t-text-neutral-10": color === "grey",
                  "t-text-neutral-20": color === "dark-grey",
                }
              )}
            >
              {children}
            </p>

            <div className="t-flex-1 t-h-px t-bg-separator-fade-right" />
          </>
        )}
      </div>
    );
  }

  return (
    <div
      className={cx("custom-divider t-flex t-items-center t-justify-center", {
        "t-h-full": fullHeight,
        [classNames]: Boolean(classNames),
      })}
    >
      <div
        className={cx("t-w-full t-border-t-0 t-border-0 t-border-neutral-0", {
          "!t-border-neutral-10": color === "grey",
          "!t-border-neutral-20": color === "dark-grey",
          "t-border-dashed": type === "dashed",
          "t-border-dotted": type === "dotted",
          "t-border-solid": type === "solid",
          "t-border-b": orientation === "horizontal",
          "t-border-l t-flex-col t-h-[calc(100%-4px)]":
            orientation === "vertical",
        })}
      ></div>
      {children && (
        <>
          <p
            className={cx("t-mx-3 t-mb-0", {
              "t-text-neutral-10": color === "grey",
              "t-text-neutral-20": color === "dark-grey",
            })}
          >
            {children}
          </p>
          <div
            className={cx(
              "t-w-full t-border-b t-border-t-0 t-border-solid t-border-neutral-0",
              {
                "!t-border-neutral-10": color === "grey",
                "!t-border-neutral-20": color === "dark-grey",
              }
            )}
          ></div>
        </>
      )}
    </div>
  );
};
